import common from '@/util/common'

export const IndexRedirect = {
  computed: {
    userInfo () {
      return common.getUserInfo()
    }
  },
  mounted () {
    // console.log('infoSourceMounted')
    let isGreenWay = false
    let isDirectLoginSuccess = sessionStorage.getItem('direct_login') === '1'
    if (sessionStorage.getItem('greenway') !== null) {
      isGreenWay = sessionStorage.getItem('greenway') === '1'
    }
    // 如果是教研员，不做跳转判断，当绿色通道处理
    if (this.userInfo.role.toString() === '3') {
      isGreenWay = true
    }
    if (!isGreenWay && !isDirectLoginSuccess) {
      if (this.userInfo.infoSources) {
        console.log('this.userInfo.infoSources = ' + this.userInfo.infoSources)
        switch (this.userInfo.infoSources) {
          case 3: // 金昌
            location.href = 'http://jcjy.talkedu.cn/trportal'
            break
          case 4: // 益阳
            location.href = 'http://data.edu.yiyang.gov.cn/apph5/eduData/'
            break
          case 6: // 西安
            location.href = 'http://zhx-htc.talkedu.cn/zhxyCloud/'
            break
          case 7: // 邵阳
            location.href = 'http://zxy.sysyz.com.cn/zhxyCloud/ '
            break
        }
      }
    }
  }
}
export const isKaowUser = {
  computed: {
    isKaowUser () {
      let kwInfoKeys = [1, 2, 5]
      let userInfoSource = common.getUserInfo().infoSources
      if (kwInfoKeys.indexOf(userInfoSource) > -1) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    // console.log('infoSourceMounted')
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/InfoSource.js